import { render, staticRenderFns } from "./InspectionPhotoAnomalies.vue?vue&type=template&id=076b64e6&scoped=true&"
import script from "./InspectionPhotoAnomalies.vue?vue&type=script&lang=ts&"
export * from "./InspectionPhotoAnomalies.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionPhotoAnomalies.vue?vue&type=style&index=0&id=076b64e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b64e6",
  null
  
)

export default component.exports